/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import Phone from '../icons/Phone';
import Pin from '../icons/Pin';
import {Image} from '@shopify/hydrogen';
import {Stockist} from '../../types';
import {useMap} from 'react-map-gl';
import {selectedMarkerAtom} from '../../jotai';
import {useAtom} from 'jotai';
import clsx from 'clsx';

export const StockistCard = (props: Stockist & {isMapBlock?: boolean}) => {
  const {stockistsMap} = useMap();
  const [selectedMarker, setSelectedMarker] = useAtom(selectedMarkerAtom);
  const phoneWithoutSpaces = props.phone.replace(/\s/g, '');

  const handleClick = () => {
    if (!props.isMapBlock) return;
    stockistsMap &&
      stockistsMap.flyTo({
        center: [props._geoloc.lng, props._geoloc.lat],
      });
    setSelectedMarker(props);
  };

  return (
    <div
      className={clsx(
        'flex gap-x-5 border-b border-[#E3E3E3]  py-5 lg:gap-x-10 lg:px-5',
        {
          'bg-light-blue':
            selectedMarker && props.objectID === selectedMarker.objectID,
          'pl-[21px] lg:pl-[52px]': props.isMapBlock,
        },
      )}
      onClick={handleClick}
    >
      <Image
        src={props.logoUrl || '/images/goodnature-placeholder.png'}
        alt={props.storeName}
        width="inherit"
        height="inherit"
        className=" w-[80px] flex-shrink-0 object-contain"
      />

      <div className="space-y-1">
        <h4 className="blockH9 font-bold">{props.storeName}</h4>
        <a href={`tel:${phoneWithoutSpaces}`} className="flex w-fit gap-x-2">
          <Phone />
          <p className="richH7">
            <span className="font-semibold">Phone:</span> {props.phone}
          </p>
        </a>
        <div className="flex gap-x-2">
          <Pin />
          <div className="richH7">
            <p>{props.address}</p>
            <a
              href={`https://www.google.com/maps/dir/?api=1&destination=${props.address}`}
              target="_blank"
              className="underline"
              rel="noreferrer"
            >
              Get directions
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
